import type { SVGProps } from 'react'
const SvgSyArrowDown = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M12.273 4a.75.75 0 0 0-.75.75v15a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path d="M6.252 12.951a.75.75 0 0 0-.531.217.75.75 0 0 0-.002 1.06l6.025 6.051a.75.75 0 0 0 1.063 0l6.023-6.05a.75.75 0 0 0-.002-1.061.75.75 0 0 0-1.06.004l-5.493 5.515-5.494-5.515a.75.75 0 0 0-.529-.22" />
		</g>
	</svg>
)
export default SvgSyArrowDown
